module.exports = __webpack_public_path__ + "img/112-laos.bc84c5bf.svg";